import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import FormCheckbox from "@ats/src/components/forms/FormCheckbox";
import { FIT_BANDS, FitHarvey } from "@ats/src/views/jobApplications/Plato/FitIndicator";

interface Props {
  activeFilters: Set<string>;
  onChange: (nextFilters: Set<string>) => void;
}

const FitFilterCheckboxes: React.FunctionComponent<Props> = ({ activeFilters, onChange }) => {
  const handleFilterChange = (name: string, value: boolean) => {
    const key = name.replace("all-filters-fit-", "");
    const nextFilters = new Set(activeFilters);
    if (value) {
      nextFilters.add(key);
    } else {
      nextFilters.delete(key);
    }
    onChange(nextFilters);
  };

  return (
    <Styled.Grid>
      {FIT_BANDS.map((band: any) => (
        <Styled.Row key={band.key}>
          <FormCheckbox
            name={`all-filters-fit-${band.key}`}
            label={band.label}
            checked={activeFilters.has(band.key)}
            onChange={handleFilterChange}
          />
          <FitHarvey value={band.fill} />
        </Styled.Row>
      ))}

      <Styled.Row>
        <FormCheckbox
          name="all-filters-fit-unscored"
          label="Not yet scored"
          checked={activeFilters.has("unscored")}
          onChange={handleFilterChange}
        />
      </Styled.Row>
    </Styled.Grid>
  );
};

export default FitFilterCheckboxes;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Grid = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: FitFilterCheckboxes;
    display: grid;
    /* Column-major: the bands read top to bottom down the left column, then down
       the right. Row-major would interleave them across the two columns. */
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(3, auto);
    gap: 0 ${t.spacing[4]};
  `;
});

Styled.Row = styled.div`
  label: FitFilterCheckboxes_Row;
  display: flex;
  align-items: center;
  gap: 6px;

  /* the checkbox holds a fixed column so every ball lands on the same x */
  > div:first-of-type {
    width: 8.25rem;
    flex: none;
  }

  svg {
    flex-shrink: 0;
  }
`;
